import dayjs, { Dayjs } from "dayjs";
import SalarySimInputPostData from "./SalarySimInputPostData";


export class ClDonneesPrevSimulation
{
    IdTechnique : number = 0;
    ItUtilisateur : number = 0;
    IdApplication : string = "";
    IdFonction : string = "";
    
    Sauvegarde : SalarySimInputPostData = new SalarySimInputPostData();

    DtCreation : Dayjs = dayjs();
    AuteurCreation : string = "";
    DtModification : Dayjs = dayjs();
    AuteurModification : string = "";
}

export class PrevSimulRequest {
    username: string = "";
    datebegin: Dayjs = dayjs();
    dateEnd: Dayjs = dayjs();
  }

